module.exports = __webpack_public_path__ + "img/amex.62a50de7.svg";